import ThemeProvider from "react-bootstrap/ThemeProvider";
import { AuthProvider } from "@hooks/contexts/auth-context";
import { BrowserRouter } from "react-router-dom";
import { ModalProvider } from "@hooks/contexts/modal-context";
import { SidebarCollapseProvider } from "@hooks/contexts/SidebarCollapseContext";
import { TopbarCollapseProvider } from "@hooks/contexts/TopbarCollapseContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AppRoutes from "routes";
import { config } from "config";

function ToastContainerWrapper() {
  return <ToastContainer />;
}

function App() {
  document.title = `Painel - ${config.appName}`;

  return (
    <ThemeProvider
      breakpoints={["xxxl", "xxl", "xl", "lg", "md", "sm", "xs", "xxs"]}
      minBreakpoint="xxs"
    >
      <BrowserRouter>
        <AuthProvider>
          <ModalProvider>
            <TopbarCollapseProvider>
              <SidebarCollapseProvider>
                <AppRoutes />
              </SidebarCollapseProvider>
            </TopbarCollapseProvider>
          </ModalProvider>
        </AuthProvider>
        <ToastContainerWrapper />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
